export const DEFAULT_LANGUAGE = 'en';
export const PREFERRED_LANGUAGE = 'PREFERRED_LANGUAGE';

export const LAYOUT_DEFAULT_SLIDE_MODE = 'LAYOUT_DEFAULT_SLIDE_MODE';
export const LAYOUT_DEFAULT_SLIDE_WIDTH = 'LAYOUT_DEFAULT_SLIDE_WIDTH';

export const LAYOUT_STUFF_TO_EAT_LIST_SLIDE_MODE = 'LAYOUT_STUFF_TO_EAT_LIST_SLIDE_MODE';
export const LAYOUT_STUFF_TO_EAT_VIEW_SLIDE_MODE = 'LAYOUT_STUFF_TO_EAT_VIEW_SLIDE_MODE';

export const LAYOUT_PROGRAMS_LIST_SLIDE_MODE = 'LAYOUT_PROGRAMS_LIST_SLIDE_MODE';
export const LAYOUT_PROGRAMS_VIEW_SLIDE_MODE = 'LAYOUT_PROGRAMS_VIEW_SLIDE_MODE';

export const LAYOUT_MY_TEAM_LIST_SLIDE_MODE = 'LAYOUT_MY_TEAM_LIST_SLIDE_MODE';
export const LAYOUT_MY_TEAM_VIEW_SLIDE_MODE = 'LAYOUT_MY_TEAM_VIEW_SLIDE_MODE';

export const LAYOUT_SYS_ADMIN_INSTANCE_DETAILS = 'LAYOUT_SYS_ADMIN_INSTANCE_DETAILS';

export const FORM_EVOLUTION_CRED_MEASUREMENT = 'FORM_EVOLUTION_CRED_MEASUREMENT';

export const RECENTLY_MODIFIED = 'recently_modified';

export const PAGE_HOME_DASHBOARD = 'PAGE_HOME_DASHBOARD';
export const PAGE_EVOLUTION_DASHBOARD = 'PAGE_EVOLUTION_DASHBOARD';
export const PAGE_DIETS_LIST = 'PAGE_DIETS_LIST';
export const PAGE_SEARCH_STUFF_TO_EAT = 'PAGE_SEARCH_STUFF_TO_EAT';
export const PAGE_ALLERGENS_LIST = 'PAGE_ALLERGENS_LIST';

export const INSTANCE_REGISTRATION = 'INSTANCE_REGISTRATION';

export const ADDED_BY_ME = 'added_by_me';



// WEBPACK FOOTER //
// ./src/constants/keys.js